import { type Signal, signal } from '@preact/signals-core';

let cached: Signal<boolean> | null = null;

/**
 * Lazily installed window-level Shift-key tracker. All views share the
 * same signal — hitting Shift anywhere in the app flips the value. The
 * listener is installed exactly once on first access. Blur on the
 * window resets to false so the state cannot stay stuck if the user
 * alt-tabs while holding Shift.
 */
export function getShiftKeyActive$(): Signal<boolean> {
  if (cached) return cached;
  const sig = signal(false);
  cached = sig;
  if (typeof window === 'undefined') return sig;
  const onKey = (evt: KeyboardEvent): void => {
    if (evt.key !== 'Shift') return;
    sig.value = evt.type === 'keydown';
  };
  const onBlur = (): void => {
    sig.value = false;
  };
  window.addEventListener('keydown', onKey);
  window.addEventListener('keyup', onKey);
  window.addEventListener('blur', onBlur);
  return sig;
}
